export default "__VITE_ASSET__CQrk8a2j__"